import * as React from 'react';
import { compose, defaultProps } from 'recompose';
import { createStyles } from '@material-ui/core/styles';
import { Panel, withBaseProps } from '@topconagriculture/react-components';
const styles = (theme) => createStyles({
    root: {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        overflow: 'hidden',
    },
});
const MapPanel = (props) => {
    const { classes, children } = props;
    return React.createElement(Panel, { className: classes.root }, children);
};
export default compose(withBaseProps({ styles }), defaultProps({
    defaultPadding: true,
}))(MapPanel);
//# sourceMappingURL=MapPanel.js.map